module.exports = __webpack_public_path__ + "static/media/gradient-startX-icon.d644417c.svg";